<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Refunded Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :loggedInUserData="loggedInUserData"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td
                  style="min-width: 65px; max-width: 65px;"
                  class="hover-container"
                >
                  <view-order-users :orderData="r" />
                </td>
                <td>{{ r.last_order_invoice }}</td>
                <td>{{ r.theOrderID }}</td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td>{{ r.user_id }}</td>
                <td class="ws-nowrap">
                  <i v-if="r.fcm_token" class="material-icons customer-device-icon">smartphone</i>
                  <i v-else class="material-icons customer-device-icon">language</i>
                  <img v-if="r.profile_image" :src="`${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                    {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                  </span>
                  <span v-else>
                    {{ r.full_name }}
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.phone_number }}</td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                </td>
                <td>{{
                  r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : '')
                }}</td>
                <td>{{ r.quantity }}</td>
                <td>{{ r.item_price }}</td>
                <td>{{ r.internal_shipping_handling }}</td>
                <td>{{ r.national_tax }}</td>
                <td>{{ r.tax }}</td>
                <td>{{ r.kreenex_fee }}</td>
                <td>{{ r.discount }}</td>
                <td>{{ r.country }}</td>
                <td>{{ r.bank_name }}</td>
                <td>{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '' }}</td>
                <td>{{ r.note }}</td>
                <td>{{ r.refund_number }}</td>
                <td
                  style="min-width: 130px"
                  class="hover-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.refund_note }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left:10px; padding-right:5px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
                <td
                  v-if="$_has_perm('add_refund_number')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#039a7c"
                    tooltip="Add refund number"
                    @click="openAddRefundNumberModal(r.order_id, r.refund_number)"
                  >
                    <i class="material-icons">add_circle</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.theOrderID }} , <br />
                  {{
                    r.product_name.substr(0, 35) +
                      (r.product_name.length > 35 ? '...' : '')
                  }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                      (r.product_url.length > 10 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer ID: {{ r.user_id }} , <br />
                  Name: {{ r.full_name }} , <br />
                  {{ r.note }}, <br />
                  {{ r.refund_number }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  Confirm date: {{ r.confirm_date }} , <br />
                  <span>{{ r.refund_note }}</span>
                  <a
                    style="color:#01579B; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <add-refund-number
            :addRefundNumberData="addRefundNumberData"
            :closeAddRefundNumberModal="closeAddRefundNumberModal"
            :addRefundNumberModal="addRefundNumberModal"
            :successAlert="successAlert"
            :addRefundNumber="addRefundNumber"
          ></add-refund-number>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import mobileDatatable from './mobileDatatable'
import addRefundNumber from './addRefundNumber'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'mobile-datatable': mobileDatatable,
    'add-refund-number': addRefundNumber
  },
  mounted() {
    this.getLoggedInUser()
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      {
        label: 'User',
        text: 'User',
        value: '2',
        sortable: false,
        searchable: false,
        name: 'user'
      },
      {
        label: 'Invoice Number',
        text: 'Invoice Number',
        value: '3',
        sortable: true,
        searchable: false,
        name: 'last_order_invoice'
      },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'user_id'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Customer Note',
        text: 'Customer Note',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'cutomer_note'
      },
      {
        label: 'Phone Number',
        text: 'Phone Number',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'phone_number'
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'product_url'
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: 'Qty',
        text: 'Qty',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'quantity'
      },
      {
        label: 'Item Price',
        text: 'Item Price',
        value: '12',
        sortable: true,
        searchable: true,
        name: 'item_price'
      },
      {
        label: 'Shipping',
        text: 'Shipping',
        value: '13',
        sortable: true,
        searchable: true,
        name: 'internal_shipping_handling'
      },
      {
        label: 'Int. Tax',
        text: 'Int. Tax',
        value: '14',
        sortable: true,
        searchable: true,
        name: 'national_tax'
      },
      {
        label: 'Tax',
        text: 'Tax',
        value: '15',
        sortable: true,
        searchable: true,
        name: 'tax'
      },
      {
        label: 'Shipzone Fee',
        text: 'Shipzone Fee',
        value: '16',
        sortable: true,
        searchable: true,
        name: 'kreenex_fee'
      },
      {
        label: 'Discount',
        text: 'Discount',
        value: '17',
        sortable: true,
        searchable: true,
        name: 'discount'
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '18',
        sortable: true,
        searchable: true,
        name: 'country'
      },
      {
        label: 'Back Name',
        text: 'Back Name',
        value: '19',
        sortable: true,
        searchable: true,
        name: 'bank_name'
      },
      {
        label: 'Type',
        text: 'Type',
        value: '20',
        sortable: true,
        searchable: true,
        name: 'transportation_type_obj',
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '21',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: 'Refund Number',
        text: 'Refund Number',
        value: '22',
        sortable: true,
        searchable: true,
        name: 'refund_number'
      },
      {
        label: 'Date',
        text: 'Date',
        value: '23',
        sortable: true,
        searchable: true,
        name: 'refund_date'
      },
      {
        label: 'Refund Note',
        text: 'Refund Note',
        value: '24',
        sortable: true,
        searchable: true,
        name: 'refund_note'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      loggedInUserData: {},
      isMobile: false,
      url: 'api/refunded_order',
      orderDetailUrl: 'api/show_order_detail',
      addRefundNumberUrl: 'api/add_refund_number',
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      addRefundNumberModal: false,
      orderID: '',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        coupon_percentage: '',
        type: '',
        theOrderID: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        bank_name: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        discount: '',
        item_type: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        note: ''
      },
      prevSearchQuery: '',
      addRefundNumberData: {
        refund_number: ''
      },
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'orders.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    sendToExport() {
      let searchValue = this.tableData.search !== '' ? this.tableData.search : '0'
      let column = this.tableData.column !== '' ? this.tableData.column : '0'
      let sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0'
      let searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0'
      let searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0'
      let fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0'
      let toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0'
      let loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
      let warehouses = loggedInUserData.warehouse_id_fk
      let perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page

      if (
        searchValue !== '0' ||
        searchedOneCol !== '0' ||
        searchedOneVal !== '0' ||
        toDate !== '0' ||
        fromDate !== '0'
      ) {
        perPage = '0'
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName

      window.location.replace(
        fullHostName +
        '/api/refunded_order/export?searchValue=' +
        searchValue +
        '&column=' +
        column +
        '&sortDir=' +
        sortDir +
        '&searchedOneCol=' +
        searchedOneCol +
        '&searchedOneVal=' +
        searchedOneVal +
        '&from_date=' +
        fromDate +
        '&to_date=' +
        toDate +
        '&warehouses=' +
        warehouses +
        '&per_page=' +
        perPage +
        '&remove_pagination=true'
      )
    },

    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    openAddRefundNumberModal(orderID, refundNumber) {
      this.orderID = orderID
      this.addRefundNumberData.refund_number = refundNumber
      this.addRefundNumberModal = true
    },

    closeAddRefundNumberModal() {
      this.addRefundNumberModal = false
      this.successAlert = false
    },

    addRefundNumber() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.addRefundNumberUrl + '/' + this.orderID, this.addRefundNumberData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.successAlert = true
          this.getResults()
          let self = this
          setTimeout(() => {
            self.closeAddRefundNumberModal()
          }, 1500)
        })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'orders.updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'orders.updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'orders.updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'orders.updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/refundedOrder.vue